<template>
  <v-card>
    <v-card-title>
      {{ $t('title.settings_lock') }}
      <v-btn
        absolute
        right
        icon
        outlined
        x-small
        @click="$refs.subLock.classList.remove('d-none')"
      >
        <v-icon>mdi-help</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle
      ref="subLock"
      class="d-none"
    >
      {{ $t('title.settings_lock_desc') }}
    </v-card-subtitle>
    <v-card-text>
      <v-switch
        v-model="usepassword"
        :label="`${$t('field.settings.passwd')} ${usepassword ? 'ON' : 'OFF'}`"
        color="accent"
        hide-details
        @change="handleChangePassword"
      />
    </v-card-text>

    <password-dialog
      v-model="pwdDialog"
      saving
      @valid="validPassword"
      @cancel="cancelPassword"
    />
  </v-card>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'
import PasswordDialog from '@/components/modal/PasswordDialog'

export default {
  name: 'PasswordSettings',

  components: {
    PasswordDialog
  },

  data () {
    return {
      usepassword: this.$store.state.usepassword,
      pwdDialog: false
    }
  },

  methods: {
    handleChangePassword (val) {
      if (val) {
        this.pwdDialog = true
      } else {
        this.$store.commit('usepassword', false)
        MetierLocalStorage.setUsePwd(false)
      }
    },
    validPassword () {
      this.pwdDialog = false
      this.usepassword = true

      this.$store.commit('usepassword', true)
      MetierLocalStorage.setUsePwd(true)
    },
    cancelPassword () {
      this.pwdDialog = false
      this.usepassword = false
    }
  }
}
</script>
